import React from 'react';
import { Card, CardHeader, CardContent } from "@/components/ui/card";
import { TrendingUp, TrendingDown } from "lucide-react";

type Props = {
  title: string
  value: number | string
  trend?: 'up' | 'down'
  trendValue?: string
  icon: React.ComponentType<{ className?: string }>
  color?: 'teal' | 'yellow' | 'green' | 'blue'
  format?: 'number' | 'currency' | 'percentage'
}

export default function KPICard({
  title,
  value,
  trend,
  trendValue,
  icon: Icon,
  color = "teal",
  format = "number"
}: Props) {
    const colorClasses = {
        teal: "from-teal-500 to-teal-600 text-teal-700",
        yellow: "from-yellow-400 to-yellow-500 text-yellow-700",
        green: "from-green-500 to-green-600 text-green-700",
        blue: "from-blue-500 to-blue-600 text-blue-700"
    };

    const formatValue = (val: string | number) => {
        if (format === "currency") return `${val}M€`;
        if (format === "percentage") return `${val}%`;
        return val;
    };

    return (
        <Card className="relative overflow-hidden border-0 shadow-lg bg-white">
            <div className={`absolute top-0 right-0 w-32 h-32 transform translate-x-8 -translate-y-8 bg-gradient-to-r ${colorClasses[color]} rounded-full opacity-10`} />
            <CardHeader className="pb-3">
                <div className="flex justify-between items-start">
                    <div>
                        <p className="text-sm font-medium text-gray-600 mb-2">{title}</p>
                        <p className="text-3xl font-bold text-gray-900">
                            {formatValue(value)}
                        </p>
                    </div>
                    <div className={`p-3 rounded-2xl bg-gradient-to-r ${colorClasses[color]} bg-opacity-20`}>
                        <Icon className={`w-6 h-6 ${colorClasses[color].split(' ')[2]}`} />
                    </div>
                </div>
            </CardHeader>
            {trend && (
                <CardContent className="pt-0">
                    <div className="flex items-center gap-2">
                        {trend === "up" ? (
                            <TrendingUp className="w-4 h-4 text-green-500" />
                        ) : (
                            <TrendingDown className="w-4 h-4 text-red-500" />
                        )}
                        <span className={`text-sm font-medium ${trend === "up" ? "text-green-600" : "text-red-600"}`}>
              {trendValue}
            </span>
                        <span className="text-sm text-gray-500">vs période précédente</span>
                    </div>
                </CardContent>
            )}
        </Card>
    );
}
